export default __webpack_public_path__ + "static/media/2144.e3f89de6.png";